/*
 * @Description: 描述
 * @Author: D
 * @Date: 2024-03-12 09:34
 * @LastEditTime: 2024-06-21 08:56
 * @LastEditors: D
 * @FilePath: \admin\src\router\index.js
 */
import {
    createRouter,
    createWebHistory,
    createWebHashHistory,
} from "vue-router";
import Login from "@/views/Login/index.vue";
import CarDetail from "@/views/CarDetail/index.vue";
import Layout from "@/Layout/index.vue";
import store from "@/store";

const routes = [


    {
        path: "/",
        name: "Layout",
        redirect: "/Quotation",
        meta: {
            title: "委托列表",
        },
        component: Layout,
        children: [],
    },

    {
        path: "/login",
        name: "login",
        component: Login,
    },
    {
        path: "/carDetail",
        name: "carDetail",
        component: CarDetail,
    },

];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

const NO_LOGIN = ["/login", "/carDetail"];
router.beforeEach(async (to, from, next) => {
    // 是否需要登录
    console.log("to", window.location.href);
    console.log("from", from.path);
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams.get('id')); // 输出 URL 参数的值
    let id = urlParams.get('id');
    if(window.location.href.includes("/carDetail")){
        next();
    }


    if (NO_LOGIN.includes(to.path)) {
        console.log("无需登录");
        next();
    } else {
        let token = sessionStorage.getItem("token");
        if (token) {
            console.log("需要获取路由");
            let roleList = store.state.roleList;
            await store.dispatch("handleGetRole");
            roleList = store.state.roleList;
            if (roleList.length) {
                if (!store.state.isRouter) {
                    let newRoutes = store.getters.newRouteschildrenrouter;
                    console.log("获取到了权限 进行动态添加路由");

                    store.state.routers.map((item) => {
                        routes[0].children.push(item);
                    });
                    console.log(to, 'ssss');

                    const defaultRoutes = routes[0].children.map((item) => item.path);
                    console.log(routes[0].children.map((item) => item.path));
                    router.addRoute(routes[0]);
                    store.commit("SET_ISROUTER", true);
                    next({path: to.path, query: to.query, replace: true});
                } else {
                    next();
                }
            } else {
                console.log("权限获取失败");

                next({
                    path: "/login",
                });
            }
        } else {
            console.log("没登陆 需要登录");

            next({
                path: "/login",
            });
        }
    }
});
export default router;
